(ns quuppa.qsm.users.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  :qsm/qsm-users
  (fn [db _]
    (-> db :qsm :qsm-users)))

(rf/reg-sub
  :qsm/resource-users
  (fn [db _]
    (-> db :qsm :resource-users)))

(rf/reg-sub
  :qsm/admin-sidebar
  (fn [db _]
    (-> db :qsm :ui :admin-sidebar)))

(rf/reg-sub
  :qsm/add-user-in-progress?
  (fn [db _]
    (-> db :qsm :ui :add-user-in-progress?)))

(rf/reg-sub
  :qsm/assign-user-in-progress?
  (fn [db _]
    (-> db :qsm :ui :assign-user-in-progress?)))

(rf/reg-sub
  :qsm/add-user-form-data
  (fn [db _]
    (-> db :qsm :ui :admin-sidebar :add-user-form-data)))

(rf/reg-sub
  :qsm/add-user-failure-data
  (fn [db _]
    (-> db :qsm :ui :admin-sidebar :add-user-failed)))

(rf/reg-sub
  :qsm/edit-user-form-data
  (fn [db _]
    (-> db :qsm :ui :admin-sidebar :edit-user-form-data)))

(rf/reg-sub
  :qsm/assign-user-form-data
  (fn [db _]
    (-> db :qsm :ui :admin-sidebar :assign-user-form-data)))
